var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "maglia-or-flag-plus-nome",
      attrs: { title: _vm.calciatore.nomeClub },
    },
    [
      _c("span", {
        staticClass: "club-image",
        class: { "club-image--flag": _vm.showFlag },
        style: {
          backgroundImage: _vm.imageUrl ? "url(" + _vm.imageUrl + ")" : "",
        },
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "club-name" }, [_vm._v(_vm._s(_vm.nome))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }